import { receiptsApi } from '../api/receiptsApi'

export const sendReceiptEmail = async (donationId: string) => {
  try {
    const response = await receiptsApi.sendReceiptEmail(donationId)
    return response.data
  } catch (error) {
    console.error(`Error sending receipt email: `, error)
    throw error
  }
}
